import script from "./TypeOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeOptions.vue?vue&type=script&setup=true&lang=js"

import "./TypeOptions.vue?vue&type=style&index=0&id=5878ee4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5878ee4a"]])

export default __exports__